const AUTH_RECOVERY_EVENT = 'petronexus:auth-session-expired';

const PUBLIC_PATHS = [
  '/login',
  '/register',
  '/auth/callback',
  '/invite/accept',
  '/onboarding',
  '/forgot-password',
  '/reset-password',
  '/privacy',
  '/support',
];

let sessionExpiryRedirecting = false;

function isPublicPage(pathname: string): boolean {
  return pathname === '/' || PUBLIC_PATHS.some((path) => pathname.startsWith(path));
}

export function expireWebSession(reason = 'session_expired') {
  if (typeof window === 'undefined') return;

  window.localStorage.removeItem('token');
  window.localStorage.removeItem('user');
  window.dispatchEvent(
    new CustomEvent(AUTH_RECOVERY_EVENT, {
      detail: {
        reason,
        from: `${window.location.pathname}${window.location.search}`,
      },
    }),
  );

  if (sessionExpiryRedirecting || isPublicPage(window.location.pathname)) return;
  sessionExpiryRedirecting = true;

  const loginUrl = new URL('/login', window.location.origin);
  loginUrl.searchParams.set('reason', reason);
  loginUrl.searchParams.set('from', `${window.location.pathname}${window.location.search}`);
  window.location.href = loginUrl.toString();

  window.setTimeout(() => {
    sessionExpiryRedirecting = false;
  }, 3000);
}

export function resetSessionExpiryRedirectForTest() {
  sessionExpiryRedirecting = false;
}
